import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=1a5a3090&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"
import style0 from "./ProductCard.css?vue&type=style&index=0&id=1a5a3090&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5a3090",
  null
  
)

export default component.exports